import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { ResourcePlanningDayPage } from "@src/components/modules/resource-planning/timeline/ResourcePlanningDayPage";
import { FullScreenContainer } from "@src/components/ui-kit";
import { ResourcePlanningNavigation } from "@src/components/widgets/AppSubNav";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout
    fullWidth
    noGutters
    noTopMargin
    noBottomMargin
    title={t`Resource Planning`}
    navigation={<ResourcePlanningNavigation />}
  >
    <DemoModule module={Modules.ResourcePlanning}>
      <FullScreenContainer heightOffset="-4rem" noBottomMargin>
        <ResourcePlanningDayPage />
      </FullScreenContainer>
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/resource-planning/")({
  component: Page,
});
